export default "__VITE_PUBLIC_ASSET__6ff6a8de__"